/**
 * Query keys for clinician diagnosis mutations.
 */
export const diagnosesKeys = {
  all: ['diagnoses'] as const,

  record: (userId: string) => ['diagnoses', 'record', userId] as const,
};
